import {getApprovalProcessById} from "../../../../api/approval/ApprovalProcessService";
import {store} from "../../../../redux/store/store";
import {setApprovalProcess, setApprovalProcessAfter} from "../../../../redux/slice/contentSlice";

let preloadGeneration = 0;

export function getCodeApprovalProcessIds(codeEntry) {
    if (!codeEntry) {
        return {beforeId: null, afterId: null};
    }

    return {
        beforeId: codeEntry.approvalProcessId ?? codeEntry.approvalProcess?.id ?? null,
        afterId: codeEntry.approvalProcessIdAfter ?? codeEntry.approvalProcessAfter?.id ?? null,
    };
}

/**
 * 접수/등록 API 호출 직전 redux에서 최신 결재라인 ID를 읽는다.
 */
export function getApprovalProcessSubmitPayload({includeAfter = false} = {}) {
    const {approvalProcess, approvalProcessAfter} = store.getState().content;
    const payload = {
        approvalProcessId: approvalProcess?.id,
        approvalProcessName: approvalProcess?.name,
    };

    if (includeAfter) {
        payload.approvalProcessIdAfter = approvalProcessAfter?.id;
        payload.approvalProcessNameAfter = approvalProcessAfter?.name;
    }

    return payload;
}

/** 접수/등록 화면 진입·이탈 시 redux 결재라인 상태 초기화 */
export function clearApprovalProcessState(dispatch) {
    preloadGeneration += 1;
    dispatch(setApprovalProcess({}));
    dispatch(setApprovalProcessAfter({}));
}

/**
 * 코드에 연결된 결재라인을 redux에 preload한다.
 */
export function preloadApprovalProcesses(dispatch, {beforeId, afterId} = {}) {
    const generation = ++preloadGeneration;

    dispatch(setApprovalProcess({}));
    if (beforeId != null) {
        getApprovalProcessById(beforeId).then((response) => {
            if (generation !== preloadGeneration) {
                return;
            }
            if (response?.status === 200) {
                dispatch(setApprovalProcess({...response.data}));
            }
        });
    }

    dispatch(setApprovalProcessAfter({}));
    if (afterId != null) {
        getApprovalProcessById(afterId).then((response) => {
            if (generation !== preloadGeneration) {
                return;
            }
            if (response?.status === 200) {
                dispatch(setApprovalProcessAfter({...response.data}));
            }
        });
    }
}

export function preloadApprovalProcessFromCodeEntry(dispatch, codeEntry, {includeAfter = true} = {}) {
    const {beforeId, afterId} = getCodeApprovalProcessIds(codeEntry);
    preloadApprovalProcesses(dispatch, {
        beforeId,
        ...(includeAfter ? {afterId} : {}),
    });
}

export function preloadApprovalProcessFromFlatCode(dispatch, codeId, flatCodeList, options) {
    if (!codeId || !flatCodeList?.length) {
        clearApprovalProcessState(dispatch);
        return;
    }

    const codeEntry = flatCodeList.find((item) => item.id === codeId);
    preloadApprovalProcessFromCodeEntry(dispatch, codeEntry, options);
}
